/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {SurveyFormInputText} from "../SurveyFormInputText";
import {SurveyFormInputBoolean} from "../SurveyFormInputBoolean";
import {SurveyFormComposedInput} from "../SurveyFormComposedInput";

export const SurveyFormBooleanWithTextInput = (props) => 
    <SurveyFormComposedInput Validation={props.Validation}>
        <SurveyFormInputBoolean {...props} Validation={null}/>
        <SurveyFormInputText {...props} Validation={null}/>
    </SurveyFormComposedInput>;
